// extracted by mini-css-extract-plugin
module.exports = {"icon":"carousel_icon__icnAg"};